import React, { useState } from "react";
import { Checkbox, Control, Delete, Field, Input } from "@allxsmith/bestax-bulma";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";



function Instruction({
  instruction,
  index,
  updateInstructions,
  removeInstruction,
  type
}) {

  const handleChange = e => {
    const newInstruction = getNewInstruction(e);
    updateInstructions(newInstruction, index);
  };


  const getNewInstruction = e => {
    let newInstruction = { ...instruction, [e.target.name]: e.target.value };
    return newInstruction;
  };
  const onCheck = () => {
    handleChange({target: {name: 'on_completion', value: !instruction.on_completion}});
  }

  return (
    <tr>
      <td className={"comments-wrapper"}>
        <Field className="has-addons">
          <Control className="comments-wrapper">
            <Input
              type="text"
              value={instruction.text}
              name="text"
              onChange={handleChange}
              data-testid="part-name"
              className={"comments-box"}
            />
          </Control>
        </Field>
      </td>
      {type === 'Workshop' &&
        <td>
          <Field>
            <Control>
              <Checkbox
                type="checkbox"
                name="on_completion"
                onChange={(e) => onCheck(e)}
                checked={instruction.on_completion}
              />
            </Control>
          </Field>
        </td>
      }
      <td className="instructions-remove-button">
        <Delete onClick={() => removeInstruction(index)} data-testid="remove-part">
          Remove
        </Delete>
      </td>
    </tr>
  );
}
export default Instruction;
